import { useEffect, useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAnaliseCoberturaStore } from '../AnaliseCobertura.store';
import * as service from '../services';
import { BigNumbersMutateParamsType } from '../types';

export const useAnaliseCoberturaBigNumbers = () => {
  const [coberturaStatus, setCoberturaStatus] = useState(null);

  const { setCoverageAnalysisState } = useAnaliseCoberturaStore();

  const bigNumbersSuccess = data => {
    setCoverageAnalysisState('bigNumbersData', data.data);
    setCoberturaStatus(data.status);

    if (data.status === 204) {
      setTimeout(() => {
        mutation.mutateAsync({ diasAnalise: 90 });
      }, 60000);
    }
  };

  const mutation = useMutation({
    mutationFn: (data: BigNumbersMutateParamsType) => service.getAnaliseCoberturaBigNumbers(data),
    onSuccess: data => bigNumbersSuccess(data),
    onError: error => {
      setCoberturaStatus(error?.response?.status);
    },
  });

  const handleChangeBigNumbersPeriod = (value: number) => {
    const dias = { diasAnalise: value } as BigNumbersMutateParamsType;
    mutation.mutateAsync(dias);
  };

  useEffect(() => {
    mutation.mutateAsync({ diasAnalise: 90 });
  }, []);

  return {
    coberturaStatus,
    isLoading: mutation.isLoading,
    handleChangeBigNumbersPeriod,
  };
};
